import { topMain } from './index';

const topFirst = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;
    let sH = window.innerHeight;

    const jsSecMain = document.getElementById('jsSecMain');
    let imgArea = jsSecMain.querySelector('.js-img-area');
    let maskSvg = jsSecMain.querySelector('.js-mask-svg');
    let path = jsSecMain.querySelector('.js-mask-svg path');
    let maskCopy = jsSecMain.querySelector('.js-mask-copy');

    let imgAreaW = imgArea.clientWidth;
    let imgAreaH = imgArea.clientHeight;


    let vol

    if (imgAreaW > imgAreaH) {
      vol = imgAreaW / 90
    } else {
      vol = imgAreaH / 80
    }
    // console.log(vol);


    gsap.set(path, {
      scale: 0,
    });

    setTimeout(() => {
      gsap.to(path, {
        scale: 1,
        duration: 1,
        ease: "power1.out",
      });
    }, 1000);

    setTimeout(() => {
      maskCopy.classList.add('act')
    }, 2000);

    setTimeout(() => {
      maskCopy.classList.remove('act')

      gsap.to(path, {
        scale: vol,
        x: imgAreaW / 2 - 60,
        duration: 2,
        ease: "power1.inOut",
      });
    }, 6000);

    setTimeout(() => {
      topMain()
    }, 8000);

    setTimeout(() => {
      maskSvg.style.display = 'none'
      maskCopy.style.display = 'none'
    }, 9000);




  }
}
export default topFirst;